(function () {
  const SYNC_SOURCE = 'arteeq-customization-sync';
  const HORIZON_CART_SOURCE = 'cart-items-component';

  let isSyncing = false;

  function getSectionsToRender() {
    const sectionIds = new Set();

    document.querySelectorAll('[data-section-id]').forEach((el) => {
      if (el.dataset.sectionId) {
        sectionIds.add(el.dataset.sectionId);
      }
    });

    return Array.from(sectionIds);
  }

  function dispatchCartUpdate(cartResponse) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartResponse,
          sourceId: SYNC_SOURCE,
          data: {
            itemCount: cartResponse.item_count,
            source: SYNC_SOURCE,
            sections: cartResponse.sections || {}
          }
        }
      })
    );
  }

  async function updateCustomizationQuantity(childKey, quantity) {
    const sections = getSectionsToRender();

    const response = await fetch(
      window.Shopify.routes.root + 'cart/change.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: childKey,
          quantity: quantity,
          sections: sections.join(','),
          sections_url: window.location.pathname
        })
      }
    );

    if (!response.ok) {
      throw new Error('Failed to sync customization quantity');
    }

    return response.json();
  }

  document.addEventListener('cart:update', async (event) => {
    // Ignore updates generated by this script itself
    if (event.detail?.data?.source === SYNC_SOURCE) {
      return;
    }

    // Only react to Horizon quantity changes
    if (event.detail?.data?.source !== HORIZON_CART_SOURCE) {
      return;
    }

    if (isSyncing) {
      return;
    }

    const cart = event.detail?.resource;

    if (!cart || !Array.isArray(cart.items)) {
      return;
    }

    const itemsByKey = new Map(
      cart.items.map((item) => [item.key, item])
    );

    for (const child of cart.items) {
      // Only our customization child
      if (child.properties?._customization_addon !== 'true') {
        continue;
      }

      const parentKey =
        child.parent_relationship?.parent_key;

      if (!parentKey) {
        continue;
      }

      const parent = itemsByKey.get(parentKey);

      if (!parent) {
        continue;
      }

      // Already synchronized
      if (parent.quantity === child.quantity) {
        continue;
      }

      try {
        isSyncing = true;

        const updatedCart =
          await updateCustomizationQuantity(
            child.key,
            parent.quantity
          );

        dispatchCartUpdate(updatedCart);

      } catch (error) {
        console.error('[Customization Sync]', error);
      } finally {
        isSyncing = false;
      }

      break;
    }
  });
})();